<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex">
          <div class="mr-2">
            <DateRangePicker
              ref="selectedRange"
            />
          </div>
          <div class="mr-2">
            <select class="form-control" v-model="selectedDivision">
              <option value="0">Все дивизионы</option>
              <option v-for="div in $AllDivisions" :value="div.id">{{ div.title }}</option>
            </select>
          </div>
          <div>
            <LoadingButton
              title='Показать'
              :loading="loading"
              :onClick="() => showReport()"
              :color="$constants.PRIMARY_COLOR"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="records && !loading">
          <table class="table table-hover table-sm">
            <thead>
            <tr>
              <th>Дата</th>
              <th>Дивизион</th>
              <th>Начало</th>
              <th>Конец</th>
              <th>Детали</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="r in records">
              <td>{{ printDate(r.date, 'DD.MM.YYYY') }}</td>
              <td>{{ $AllDivisions[r.division_id].title }}</td>
              <td>
                <p v-for="(b, curr) in r.data.balance.start" v-if="b.orders">{{ $AllCurrencies[curr].currency }}:
                  <strong>{{ b.orders.toLocaleString('ru-RU') }}</strong></p>
              <td>
                <p v-for="(b, curr) in r.data.balance.end" v-if="b.orders">{{ $AllCurrencies[curr].currency }}:
                  <strong>{{ b.orders.toLocaleString('ru-RU') }}</strong></p>
              </td>
              <td>
                <p>Заявки: <strong>{{ r.data.orders.total_price.toLocaleString('ru-RU') }}</strong></p>
                <p>ЗП: <strong>{{ r.data.orders.total_salary.toLocaleString('ru-RU') }}</strong></p>
                <p>ПР: <strong>{{ r.data.orders.total_post.toLocaleString('ru-RU') }}</strong></p>
                <p>Сдать: <strong>{{ r.data.orders.total_pass_wo_salary.toLocaleString('ru-RU') }}</strong></p>
                <p>Себестоимость: <strong>{{ r.data.orders.total_cost.toLocaleString('ru-RU') }}</strong></p>
              </td>
              <td>
                <template v-if="r.data.expenses && r.data.expenses.length">
                  <p>Расходы</p>
                  <p v-for="e in r.data.expenses">{{ $AllCurrencies[e.currency_id].currency }}:
                    <strong>{{ e.sum.toLocaleString('ru-RU') }}</strong> <span v-if="e.comment">({{ e.comment }})</span>
                  </p>
                </template>
                <template
                  v-if="(r.data.incomes.in && r.data.incomes.in.length) || (r.data.incomes.out && r.data.incomes.out.length)">
                  <p>Инкассации</p>
                  <p v-for="e in r.data.incomes.in">{{ $AllCurrencies[e.currency_id].currency }}:
                    <strong>+{{ e.sum.toLocaleString('ru-RU') }}</strong> <span v-if="e.comment">({{
                        e.comment
                      }})</span>
                  </p>
                  <p v-for="e in r.data.incomes.out">{{ $AllCurrencies[e.currency_id].currency }}:
                    <strong>-{{ e.sum.toLocaleString('ru-RU') }}</strong> <span v-if="e.comment">({{
                        e.comment
                      }})</span>
                  </p>
                </template>
                <template v-if="r.data.exchanges && r.data.exchanges.length">
                  <p>Покупка</p>
                  <p v-for="e in r.data.exchanges">{{ $AllCurrencies[e.currency_id].currency }}:
                    <strong>{{ e.sum.toLocaleString('ru-RU') }}</strong> <span>({{
                        Math.round(1 / e.rate * 100) / 100
                      }})</span>
                  </p>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
        <template v-if="!records && !loading">
          Выберите дату
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DateSelect from "@/views/reports/components/DateSelect";
import LoadingButton from "@/components/buttons/LoadingButton";
import DateRangePicker from "@/components/dateSelect/DateRangePicker";
import moment from "moment/moment";

export default {
  components: {
    DateSelect,
    LoadingButton,
    DateRangePicker,
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  data() {
    return {
      loading: false,
      records: null,
      selectedDivision: 0,
    }
  },
  methods: {
    async showReport() {
      this.loading = true;
      const {data} = await api.post('/reports/history', {
        division_id: this.selectedDivision,
        dateRange: this.$refs.selectedRange.dateRange,
      })
      if (data.success) {
        this.records = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
